import React from 'react';
import Label from 'components/form/Label/Label';
import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';

const SesameGuarantee = props => {
  const { customClass = 'text-12 margb22 text-center' } = props;
  return (
    <FlexContainer className={customClass}>
      <span>
        <b>Sesame Guarantee:</b> You’ll be approved for this card or get $25
        Sesame Cash on us!{' '}
        <Label
          className="inline pointer fontBlue100"
          onClick={props.goToViewProgramTerms}
        >
          View Program Terms
        </Label>
      </span>
    </FlexContainer>
  );
};

export default SesameGuarantee;
